import { render } from "./NotFound.vue?vue&type=template&id=46a88b29&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=46a88b29&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a88b29"],['__file',"src/views/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46a88b29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46a88b29', __exports__)) {
    console.log('reload')
    api.reload('46a88b29', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=46a88b29&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('46a88b29', render)
  })

}


export default __exports__